import { api } from './api';

export interface QueryCannibalization {
  id: number;
  tenantId: string;
  siteId: number;
  query: string;
  competingPages: string[];
  pageCount: number;
  pageMetrics: Record<string, unknown> | null;
  totalImpressions: number;
  totalClicks: number;
  avgPosition: number;
  positionVariance: number;
  isSevere: boolean;
  severityScore: number;
  primaryPage: string | null;
  redirectCandidates: string[] | null;
  dateFrom: string;
  dateTo: string;
  computedAt: string;
}

export interface CannibalizationSummary {
  totalIssues: number;
  severeIssues: number;
}

export const getCannibalizationIssues = async (
  siteId: number,
  severe?: boolean,
  limit?: number
): Promise<QueryCannibalization[]> => {
  const params = new URLSearchParams();
  if (severe !== undefined) params.append('severe', String(severe));
  if (limit) params.append('limit', String(limit));
  const qs = params.toString();
  const response = await api.get<QueryCannibalization[]>(
    `/earlystage/sites/${siteId}/cannibalization${qs ? `?${qs}` : ''}`
  );
  return response.data;
};

export const getCannibalizationSummary = async (siteId: number): Promise<CannibalizationSummary> => {
  const response = await api.get<CannibalizationSummary>(
    `/earlystage/sites/${siteId}/cannibalization/summary`
  );
  return response.data;
};
